import React from 'react';
import ReactDOM from 'react-dom';

import core from '~/core/scripts';
import '../styles/index.styl';
import ScrollApp from './ScrollApp';
import SmallMultiples from './SmallMultiples';
import EastWestChart from './EastWestChart';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

ReactDOM.render(<ScrollApp />, document.querySelector('#scroll-app'));
ReactDOM.render(<SmallMultiples />, document.querySelector('#smallmultiples'));
ReactDOM.render(<EastWestChart />, document.querySelector('#eastwestchart'));

// this is just for development purposes -> if we are looking at a layout-sample,
// we check if there is a corresponding js file
if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!../index.html');
}
